import React from 'react';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Header from './Header/Header';
import Body from './Body/Body';

const layout = (props) => {
    
    return (
        <Auxiliary>
            <Header />
            <Body rooms={props.rooms}>
                {props.children}
            </Body>
        </Auxiliary>
    );
};

export default layout;